import React from 'react'
import Left_menu from './Left_menu'
import Header from './Header'
import Billing_nav from './Billing_nav'
import { useNavigate } from 'react-router-dom'
// import Customer_header from './Customer_header'
import axios from "axios";
import Swal from 'sweetalert2';

import Moment from 'react-moment';

import ReactLoading from 'react-loading';
import config from "../../config"
import { useNetworkState } from 'react-use';
import Footer from '../Footer'

const Billing_cod_remittance = () => {
  let userDetail = localStorage.getItem('ship_rocket_user');
  // // console.log("userDetail====", config.UserId);
  let userData = {};
  if (userDetail != null) {
    userData = JSON.parse(userDetail)
  }
  let navigate = useNavigate()
  const isOnline = useNetworkState();
  // console.log("isONline  === " ,isOnline )
  const [state, setState] = React.useState({ wallet_balance: "" })
  const [balancestate, setbalanceState] = React.useState({ add_balance: [], total_balance: [] })
  const [dimensionState, setdimensionState] = React.useState({ companyDetail: [] })
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
  const [transaction, settransaction] = React.useState([])
  const [codremitted, setcodremitted] = React.useState({ last_cod_remitted: 0, next_cod_remitted: 0, remittance_due: 0 })
  const [remittancedetail, setremittancedetail] = React.useState({
    last_remittance: 0, total_remittance_generated: 0, next_remittance: 0,
    total_remittance_paid_in_bank
      :
      0,
    total_wallet_deduction_from_cod
      :
      0, cod_payment_type: ""
  })

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector('.home-section');
    if (homeSection) {
      homeSection.classList.toggle('sidebar-closed');
    }
  };
  React.useEffect(() => {
    get_cod_wallet_balance()
    dimension_detail()
    cod_wallet_transactions()
    remittanceDetail()
  }, [])

  const get_cod_wallet_balance = () => {
    let dataToSend = { customer_id: userData.customer_id };

    // // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + '/user/get_cod_wallet_balance';
    axios.post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // // console.log("responseJson => ", res);
        if (res.data.status == true) {
          setbalanceState({ add_balance: res.data.added_wallet_transactions, total_balance: res.data.find_customer_wallet })
        }
        else {
          const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000
          })
          Toast.fire({
            background: "#c2200a",
            type: 'Unsuccess',
            title: "Something Went Wrong !",
            color: "white"
          });
        }
      })

      .catch((error) => {
        const Toast = Swal.mixin({
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000
        })
        Toast.fire({
          background: "#c2200a",
          type: 'Unsuccess',
          title: "Something Went Wrong !",
          color: "white"
        });
        // // console.log(error);
      });

  }


  const remittanceDetail = () => {
    let full_api = config.apiUrl + `/user/getRemittanceDetails`;
    let sendData = {};

    axios.post(full_api, sendData, { headers: config.headers }).then(res => {
      // setdimensionState({...dimensionState,companyDetail:res.data.companyDetail});
      // // console.log("rnmmmmm", res);
      setremittancedetail({
        last_remittance: res.data.customer.last_remittance ? res.data.customer.last_remittance : 0, total_remittance_generated: res.data.customer.remittance_generated ? res.data.customer.remittance_generated : 0, next_remittance: res.data.customer.next_remittance ? res.data.customer.next_remittance : 0,

        total_remittance_paid_in_bank
          :
          res.data.customer.remittance_paid_in_bank ? res.data.customer.remittance_paid_in_bank : "",

        total_wallet_deduction_from_cod
          :
          res.data.customer.wallet_deduction_from_cod ? res.data.customer.wallet_deduction_from_cod : 0, cod_payment_type: res.data.cod_payment_type, remittance_cycle: res.data.remittance_cycle, payment_days: res.data.payment_days
      })
    }).catch((e) => {
      // toast.configure()
      //toast.error("Some thing went wrong")
      // // console.log("----error:   ", e);
    })
  }

  const dimension_detail = () => {
    let full_api = config.apiUrl + `/user/get_company_info_api`;
    let sendData = {};

    axios.post(full_api, sendData, { headers: config.headers }).then(res => {
      setdimensionState({ ...dimensionState, companyDetail: res.data.companyDetail });
      // // console.log("rnmmmmm", res);
    }).catch((e) => {
      // toast.configure()
      //toast.error("Some thing went wrong")
      // // console.log("----error:   ", e);
    })
  }

  const cod_wallet_transactions = () => {
    let dataToSend = { customer_id: userData.customer_id };

    // // console.log("datatoSend",dataToSend)
    let url = config.apiUrl + '/shipment/get_cod_wallet_transactions';
    axios.post(url, dataToSend, { headers: config.headers })
      .then((res) => {
        // // console.log("responseJson => ", res);
        if (res.data.status == true) {
          settransaction(res.data.output)
          // setcodremitted({ last_cod_remitted: res.data.last_cod_remitted, next_cod_remitted: res.data.next_cod_remitted, remittance_due: res.data.due_remittance })
        }
        else {
          const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000
          })
          Toast.fire({
            background: "#c2200a",
            type: 'Unsuccess',
            title: "Something Went Wrong !",
            color: "white"
          });
        }
      })

      .catch((error) => {
        const Toast = Swal.mixin({
          toast: true,
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000
        })
        Toast.fire({
          background: "#c2200a",
          type: 'Unsuccess',
          title: "Something Went Wrong !",
          color: "white"
        });
        // // console.log(error);
      });

  }


  return (
    <div>
      {/* <?php include 'meta.php';?> */}

      {/* <?php include 'left_menu.php';?> */}
      <Left_menu isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <div className="home-section">

        <Header />


        {/* <?php include 'billing_nav.php';?>    */}
        <Billing_nav value={8} />
        <section class="mb-3">
          <div class="">
            <div class="card border-0">
              <div class="card-body">
                <div class="row states stboxbil py-3">
                  <div class="col-12 col-md-4 mb-3">
                    <div class="stbox text-center py-4 border rounded  ">
                      {/* {balancestate.total_balance.map((sub)=>( <h5>&#8377;{parseFloat(sub.cod_wallet_balance).toFixed(2)}</h5>))}
                            <small>Total COD Amount <a href="#" data-bs-toggle="popover" data-bs-placement="top" data-bs-trigger="hover" data-bs-content="Amount to be remitted in next cycle" class="text-muted"><i class="fa fa-question-circle-o" aria-hidden="true"></i></a></small> */}

                      <div className='row'>
                        <div className='col-4'><strong>Totals (Till Date)</strong></div>
                      </div>
                      <div className='row'>
                        <div className='col-6'><small>Remittance Generated</small></div>
                        <div className='col-6'><small>{remittancedetail.total_remittance_generated}</small></div>
                        <div className='col-6'><small>Remittance Paid in Bank</small></div>
                        <div className='col-6'><small>{remittancedetail.total_remittance_paid_in_bank}</small></div>
                        <div className='col-6'><small>Wallet Deduction from COD</small></div>
                        <div className='col-6'><small>{remittancedetail.total_wallet_deduction_from_cod}</small></div>
                      </div>

                    </div>
                  </div>
                  <div class="col-12 col-md-4 mb-3">
                    <div class="stbox text-center py-4 border rounded ">
                      {/* <h5>&#8377;0.00</h5>
                            <small>Remittance Till Date</small> */}
                      <div className='row'>
                        <div className='col-4'><strong>Remittances</strong></div>
                      </div>
                      <div className='row'>
                        <div className='col-6'><small>Last Remittance</small></div>
                        <div className='col-6'><small>{remittancedetail.last_remittance}</small></div>
                        <div className='col-6'><small>Next Remittance</small></div>
                        <div className='col-6'><small>{remittancedetail.next_remittance}</small></div>

                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 mb-3">
                    <div class="stbox text-center py-4 border rounded ">
                      {/* <h5>&#8377;{codremitted.remittance_due.toFixed(2)}</h5>
                            <small>Remittance Due</small> */}
                      <div className='row'>
                        <div className='col-4'><strong>User Info </strong></div>
                      </div>
                      <div className='row'>
                        <div className='col-6'><small>COD Payment Type</small></div>
                        <div className='col-6'><small>{remittancedetail.cod_payment_type}</small></div>
                        <div className='col-6'><small>Remittance Cycle</small></div>
                        <div className='col-6'><small>{remittancedetail.remittance_cycle}</small></div>
                        <div className='col-6'><small>Payment Days</small></div>
                        <div className='col-6'><small>{remittancedetail.payment_days && remittancedetail.payment_days.length > 0 ? remittancedetail.payment_days.join(" ") : ""}</small></div>
                        <div className='col-6'><small>Default Days</small></div>
                        <div className='col-6'><small>Tuesday</small></div>
                      </div>
                    </div>
                  </div>
                  {/* <div class="col-12 col-md-2 mb-3">
                        <div class="stbox text-center py-4 border rounded ">
                       { codremitted.last_cod_remitted!=0 ?  <h5>&#8377;{codremitted.last_cod_remitted.toFixed(2)}</h5>:<h5>----</h5>}
                            <small>Last Remittance</small>
                        </div>
                    </div>
                    <div class="col-12 col-md-2 mb-3">
                        <div class="stbox text-center py-4 border rounded ">
                        {codremitted.next_cod_remitted!=0?  <h5>&#8377;{codremitted.next_cod_remitted.toFixed(2)}</h5>:<h5>----</h5>}
                            <small>Next Remittance Due</small>
                        </div>
                    </div> */}


                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="mb-3">
          <div class="container">
            <div>
              {/* <div class="input-group mb-3 input-group-sm">
                    <input type="date" class="form-control" placeholder="Search by Order ID"/>
                    <select class="form-select">
                      <option>Last one year</option>
                      <option>2022</option>
                      <option>2021</option>
                      <option>2020</option>
                    </select>
                    <input type="text" class="form-control w-25" placeholder="Search by Order ID"/>
                    <button class="btn btn-primary" type="submit">Search</button>
                </div> */}
            </div>
            <div class=" table-responsive">
              <table class="table table-bordered table_box billing_table">
                <thead>
                  <tr>
                    <th>Date/Time</th>
                    <th>Particulars</th>
                    {/* <th>Shipment</th>
                    <th>Payout Id</th> */}
                    <th>Transaction</th>
                    <th>Amount</th>
                    <th>Type</th>

                    {/* <th>Status</th> */}
                  </tr>
                </thead>
                <tbody>
                  {transaction.map((sub) => (
                    <tr>
                      <td>{sub.created}</td>
                      <td>{sub.particulars}</td>

                      {/* <td>{sub.shipment_id}</td> */}
                      {/* <td> <a className='text-decoration-none' href={`/customer/transaction_detail/${sub.payout_id}`} style={{ cursor: "pointer" }}>{sub.payout_id ? sub.payout_id : ""}</a> </td> */}
                      <td>{sub.transaction_id}</td>


                      <td>{sub.amount}</td>
                      <td>{sub.payment_type == 1 ? "Credit" : "Debit"}</td>
                      {/* <td>{sub.payment_status == 2 ? <span class="badge rounded-pill bg-success fw-400">Success</span> : sub.payment_status == 3 ? <span class="badge rounded-pill bg-warning fw-400">Under Process</span> : ""}</td> */}

                    </tr>
                  ))}

                  {/* <tr>
                        <td colspan="12" class="text-center">
                          <p>Your remittance is on its way</p>
                          <small>We release COD remittance 3 times in a week and on the 8th day from the date of delivery.</small>
                        </td>
                      </tr> */}
                </tbody>
              </table>
            </div>
          </div>
        </section>



      </div>
      {/* <?php include 'footer.php';?> */}
      <Footer />
    </div>
  )
}

export default Billing_cod_remittance
